import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ConferenceHistoryItem } from '../../types';

type ConferenceHistoryState = {
    iterationKey?: string;
    items: ConferenceHistoryItem[];
    forceReloadOnStartup: boolean;
};

const initialState: ConferenceHistoryState = {
    items: [],
    forceReloadOnStartup: false,
};

const conferencesHistoryListSlice = createSlice({
    name: 'conferencesHistoryList',
    initialState,
    reducers: {
        setItems(
            state: ConferenceHistoryState,
            { payload }: PayloadAction<{ items: ConferenceHistoryItem[]; iterationKey?: string }>
        ) {
            state.iterationKey = payload.iterationKey;
            state.items = payload.items;
        },
        addItems(
            state: ConferenceHistoryState,
            { payload }: PayloadAction<{ items: ConferenceHistoryItem[]; iterationKey?: string }>
        ) {
            state.items.push(...payload.items);
            state.iterationKey = payload.iterationKey;
        },
    },
});

export const scrollThresholdReached = createAction('conferencesHistoryList/scrollThresholdReached');
export const forceHistoryFullReload = createAction('conferencesHistoryList/forceHistoryFullReload');
export const { setItems, addItems } = conferencesHistoryListSlice.actions;
export const conferencesHistoryListReducer = conferencesHistoryListSlice.reducer;
